function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Router } from 'react-router';
import { LOCATION_CHANGE } from './reducer';

var ConnectedRouter = /*#__PURE__*/function (_Component) {
  _inheritsLoose(ConnectedRouter, _Component);

  var _super = _createSuper(ConnectedRouter);

  function ConnectedRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "handleLocationChange", function (location) {
      var namespace = _this.props.namespace;

      _this.store.dispatch({
        type: LOCATION_CHANGE,
        payload: {
          location: location,
          namespace: namespace
        }
      });
    });

    return _this;
  }

  var _proto = ConnectedRouter.prototype;

  _proto.componentWillMount = function componentWillMount() {
    var _this$props = this.props,
        propsStore = _this$props.store,
        history = _this$props.history;
    this.store = propsStore || this.context.store;
    this.handleLocationChange(history.location);
  };

  _proto.componentDidMount = function componentDidMount() {
    var history = this.props.history;
    this.unsubscribeFromHistory = history.listen(this.handleLocationChange);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.unsubscribeFromHistory) this.unsubscribeFromHistory();
  };

  _proto.render = function render() {
    return /*#__PURE__*/React.createElement(Router, this.props);
  };

  return ConnectedRouter;
}(Component);

_defineProperty(ConnectedRouter, "propTypes", {
  store: PropTypes.object,
  history: PropTypes.object,
  children: PropTypes.node,
  namespace: PropTypes.string
});

_defineProperty(ConnectedRouter, "contextTypes", {
  store: PropTypes.object
});

export default ConnectedRouter;